export const STATE_KEY = 'theatreMetadata';
export const THEATRE_METADATA_FETCH_KEY = `fetch.${STATE_KEY}`;
